import styled from 'styled-components';

export const StandardBannerWrapper = styled.div<{
  backgroundColor: 'white' | 'gallery';
}>`
  [class*='StandardBannerstyle__FullWidthContainer-sc-'],
  [class*='ImageContainerstyle__BackgroundImage-sc-'] {
    background-color: var(--${props => props.backgroundColor}) !important;

    @media only screen and (min-width: 768px) {
      background-size: contain !important;
    }
  }
  [class*='Headingstyle__Heading-sc'] {
    font-weight: 700;
    line-height: 48px;
    font-size: 24px;

    @media only screen and (min-width: 768px) {
      font-size: 40px;
    }
  }

  [class*='ContentWrapperstyle__BannerButtonWrapper-sc'] {
    @media only screen and (min-width: 768px) {
      flex-direction: row-reverse;
      justify-content: space-between;

      a {
        width: 100%;
      }
    }
  }
`;
